// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.List__container-c242e3 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.List__scrollable-d5ee34 {
  overflow: auto;
}

.List__will-change-f012a7 {
  will-change: transform;
}

/* Fix the problem with inView component on 1156px - 1158px window width on retina displays */
.List__show-more-dedc06 {
  position: relative;
  top: -1px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/Removable/components/List/List.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA,6FAAA;AACA;EACE,kBAAA;EACA,SAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n}\n\n.scrollable {\n  overflow: auto;\n}\n\n.will-change {\n  will-change: transform;\n}\n\n/* Fix the problem with inView component on 1156px - 1158px window width on retina displays */\n.show-more {\n  position: relative;\n  top: -1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `List__container-c242e3`,
	"scrollable": `List__scrollable-d5ee34`,
	"will-change": `List__will-change-f012a7`,
	"willChange": `List__will-change-f012a7`,
	"show-more": `List__show-more-dedc06`,
	"showMore": `List__show-more-dedc06`
};
module.exports = ___CSS_LOADER_EXPORT___;
